import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import CustomDialog from '@configuratorware/configurator-frontendgui/Shared/Components/CustomDialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
const useStyles = makeStyles(
  (theme) => ({
    detailsLabel: {
      fontFamily: 'Inter',
      fontWeight: 500,
    },
    componentLabel: {
      fontFamily: 'Inter',
      fontWeight: 300,
    },
  }),
  {
    name: 'ComponentValidationDialog',
  }
);

interface Props {
  dialogTitle?: string;
  components: [];
  onCancel: () => void;
}

const ComponentValidationDialog: React.FC<Props> = ({ dialogTitle, components, onCancel, ...props }) => {
  const classes = useStyles();
  return (
    <CustomDialog
      dialogTitle={dialogTitle || t('componentValidation.title')}
      open={components !== null}
      onCancel={onCancel}
      props={props}
    >
      <DialogContent>
        <Typography className={classes.detailsLabel}>{t('componentValidation.details')}</Typography>
        <ul>
          {components &&
            components.map((component, i) => (
              <li key={i}>
                <Typography className={classes.componentLabel}>{component.title}</Typography>
              </li>
            ))}
        </ul>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} variant="contained">
          {t('okButtonLabel')}
        </Button>
      </DialogActions>
    </CustomDialog>
  );
};

export default ComponentValidationDialog;
